module.exports = __webpack_public_path__ + "img/p.6c33a8ae.jpg";